import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import { Input } from 'components/Input/Input'
import { vRequired, vStandardNumber, vMin } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import SelectPretty from 'components/Input/SelectPretty/SelectPretty'
// import FieldArrayRows from 'components/Input/FieldArrayRows'
import { Textarea } from 'components/Input/Textarea'

// const recordOptions = [
//   {
//     name: 'Yes (10c/min)',
//     value: true,
//   },
//   {
//     name: 'No',
//     value: false,
//   },
// ]

const vMin5 = vMin(5)
//
// const ArrayValueField = props => (
//   <Field component={Input} label="Number" validate={[vRequired, vStandardNumber]} {...props} />
// )

export default class ForwardCallForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo, formData } = this.props
    const submit = data => onSubmit(node, { extras: data })

    const voiceOptions = [
      {
        name: 'Male',
        value: 'man',
      },
      {
        name: 'Female',
        value: 'woman',
      },
    ]

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          Forward the call to another phone number.
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>

        <Field
          label="Number"
          name="number"
          component={Input}
          type="text"
          validate={[vRequired, vStandardNumber]}
        />

        <Field label="Whisper text" name="whisper" component={Textarea} display="standard" />

        {formData.whisper ? (
          <Field
            name="voice"
            component={SelectPretty}
            options={voiceOptions}
            label="Voice"
            // validate={[vRequired]}
          />
        ) : null}

        <Field
          label="Timeout"
          name="timeout"
          parse={value => Number(value)}
          component={Input}
          type="number"
          info="How long before the call is marked as 'not answered'. 15 seconds is a good value if you want to use voicemail."
          validate={[vRequired, vMin5]}
        />

        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Porta/PortaForwardCall/ForwardCallForm.jsx